export default __webpack_public_path__ + "static/media/ketosis@3x.17fab5f2.jpg";